import { FC, useMemo } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { useUser } from '@clerk/clerk-react'
import './payment-info.css'

// COMPONENTS
import { Column } from '@components/templates/column'
import PaymentMethodBrand from '@components/atoms/payment-method-brand'

// TYPES
import type { RouteObject } from 'react-router-dom'

// SCHEMAS
import { parseTeraUserData } from '@schemas'

// UTILITIES
import { getGroupStatus } from '@utils/temp-helpers'
import { useGroupLoaderData } from '..'
import { isNonEmptyString } from '@utils/type-checkers'
import Card from '@components/atoms/card'


interface Props { }

const PaymentInfoScreen: FC<Props> = () => {
    const { isSignedIn, user } = useUser()
    const group = useGroupLoaderData()
    const { isLocked } = getGroupStatus(group)
    const navigate = useNavigate()

    const { userPledges } = useMemo(() => [...(group.pledges || [])].reduce<{ userPledges: Pledge[] }>((prev, pledge) => {
        if (isSignedIn && isNonEmptyString(user.id)) {
            if (pledge.user?.id === user.id) return { ...prev, userPledges: [...prev.userPledges, pledge] };
            else return { ...prev }
        } else return prev
    }, { userPledges: [] }), [isSignedIn, user?.id, group.pledges])

    const billingAddress = useMemo(() => parseTeraUserData(user?.publicMetadata?.tera).address, [user?.publicMetadata.tera])

    function handleBack() {
        navigate(-1)
    }

    if (!isLocked) return <Navigate to={`/group/${group.id}`} replace={true} />
    else return (
        <Column.Content className="payment-info-screen">
            <Column.Header.Start>
                <a onClick={handleBack}>
                    <img src="/icons/arrow-left.svg" alt="back" style={{ width: '1.4rem', height: '1.4rem' }} draggable="false" />
                </a>
            </Column.Header.Start>
            <Card>
                {!!userPledges?.length &&
                    <div className="flex flex-row items-center">
                        <PaymentMethodBrand brand={userPledges[0].paymentMethod?.type === 'credit_card' ? userPledges[0].paymentMethod?.cardType || userPledges[0].paymentMethod?.type : userPledges[0].paymentMethod?.type} style={{ height: '1.75rem' }} />
                        <p className='text-body'><strong>Card ending in {userPledges[0].paymentMethod?.lastFour}</strong></p>
                    </div>
                }
                {(!!billingAddress) && (<>
                    <hr style={{ border: '1px solid var(--splitcard-gray-100)' }} />
                    <div className="flex flex-col gap-4">

                        <div className='address-cell'>
                            <p><strong>Billing Address</strong></p>
                            <p className="flex flex-col items-end text-gray-500">
                                <strong>{billingAddress.line1}</strong>
                                {!!billingAddress.line2 && <span>{billingAddress.line2}</span>}
                                <span className="text-body-2">{billingAddress.city}, {billingAddress.state}, {billingAddress.postal_code}</span>
                            </p>
                        </div>
                    </div>
                </>)}
            </Card>
        </Column.Content>
    )
}

const PaymentInfoRoute: RouteObject = {
    path: "payment-info",
    element: <PaymentInfoScreen />,
}

export default PaymentInfoRoute
